import { render, staticRenderFns } from "./performanceDetails.vue?vue&type=template&id=2fbd17bf"
import script from "./performanceDetails.vue?vue&type=script&lang=js"
export * from "./performanceDetails.vue?vue&type=script&lang=js"
import style0 from "./performanceDetails.vue?vue&type=style&index=0&id=2fbd17bf&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbd17bf')) {
      api.createRecord('2fbd17bf', component.options)
    } else {
      api.reload('2fbd17bf', component.options)
    }
    module.hot.accept("./performanceDetails.vue?vue&type=template&id=2fbd17bf", function () {
      api.rerender('2fbd17bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/performanceDetails.vue"
export default component.exports